/**
 * 客户端组别名称解析
 * talewave 品牌按访问域名区分客户端组别（ZKSN-277）：
 * hostname 含 app 时传 TaleWave（后端映射组别 279570169978204160），
 * 否则沿用品牌配置的 talewaveH5（后端映射组别 387202169890672640）
 */
import { brand, texts } from './index'

export const TALEWAVE_APP_GROUP_NAME = 'TaleWave'

const OVERRIDE_KEY = 'CLIENT_GROUP_OVERRIDE'

// 登录收敛在固定域名（泛域名无法配三方平台授权域），该域名下 hostname 判断会失效，
// 由登录跳转 URL 携带 cg 参数标识组别；登录页内部 router.push 会重写 query，须持久化
// 部分 WebView/隐私模式访问 storage 会抛错，模块加载期必须兜底，否则整站白屏
try {
  const cgFromUrl = new URLSearchParams(window.location.search).get('cg')
  // 白名单校验：目前唯一合法来源是 talewave app 域名登录跳转拼的 cg=TaleWave，
  // 其余一律忽略，防止构造 URL 篡改组别（后端查不到组名会静默回落 Rocnovel 组）
  if (brand === 'talewave' && cgFromUrl === TALEWAVE_APP_GROUP_NAME)
    sessionStorage.setItem(OVERRIDE_KEY, cgFromUrl)
}
catch {}

export function isTalewaveAppHost() {
  return brand === 'talewave' && window.location.hostname.toLowerCase().includes('app')
}

/**
 * 获取当前应传给后端的客户端组别名称
 * 优先级：登录域名的 cg 覆盖 > hostname 判断 > 品牌默认
 */
export function getClientGroupName() {
  try {
    const override = sessionStorage.getItem(OVERRIDE_KEY)
    if (override)
      return override
  }
  catch {}
  return isTalewaveAppHost() ? TALEWAVE_APP_GROUP_NAME : texts?.clientGroupName
}
